import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import useCacheQuery, {CacheQueryOpts, CacheQueryOutput} from "../../core/services/query/hooks/useCacheQuery";
import BookingHotelRoomRate from "../types/BookingHotelRoomRate";

type Output = BookingHotelRoomRate[];

export default function useGetBookingHotelRoomRatesInfo (
    bookingHotelRoomInternalId: string,
    endOn: string|undefined,
    options?: CacheQueryOpts
): CacheQueryOutput<Output> {
    const client = useAPIClient();

    return useCacheQuery<Output>(
      ["booking-by-date-room-prices", bookingHotelRoomInternalId, endOn],
        () => {
            return client.get<any>(`booking_by_date_room_prices`, {
                "roomInternalId": bookingHotelRoomInternalId,
                "itemsPerPage": 1000,
                "date[strictly_before]": endOn,
                "order[date]": "asc",
            });
        },
        options
    );
}
